const stateColors = {
    0: '#c3c3c3', //Gris
    1: '#FA4C4C', // Rojo
    2: '#ff9966', // Naranja
    3: '#4cc488ff' // Verde
}

export const getColorState = stock => {
    let state = 1

    if (stock.count < 0) state = 0
    else if (stock.count === 0) state = 1
    else if (stock.count < 2) state = 2
    else state = 3

    return stateColors[state]
}